import React, {Component} from 'react';




class UpperBarLogin extends Component {

  
  render() { 
    return (
      <React.Fragment>
        <div className="cntered-flex ">
            <div className="hp_uppermenu">
                <div className="hp_uppermenu_MOD">
                    <img src={"../../../images/site/mod.png"} alt="" />
                </div>
                <div className="hp_uppermenu_hr">
                    <img src={"../../../images/site/hr.png"}  alt=""/>
                </div>
                <div className="hp_uppermenu_title">הזמנת חופשה שנתית</div>
                <div className="hp_uppermenu_LineVer marginRight24"></div>                
            </div>						            
        </div>				
        <div className="hp_uppermenu_line"></div>	
        </React.Fragment>
    )
  }
}

export default UpperBarLogin;
